import { getModalUrl } from '../../publicUtils';
export function openModal(modalName, modalOptions) {
    this.controllerConfig.wixCodeApi.window.openModal("".concat(getModalUrl(this.componentName || '', modalName, this.controllerConfig.appParams.instance)), modalOptions);
}
//# sourceMappingURL=openModal.js.map